import { JSX } from 'react'

import { IconProps } from '../../icon'

const Google: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 32}
    id={id}
    stroke={stroke}
    viewBox='0 0 32 32'
    width={width || 32}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      fill='#ea4334'
      d='M7.5 12.5c-2.254-.624-3.92-1.957-5-4 3.616-6.803 9.283-9.303 17-7.5 7.368 1.577 7.868 4.41 1.5 8.5-5.513-3.223-10.013-2.223-13.5 3Z'
      style={{
        opacity: 0.901,
      }}
    />
    <path
      fill='#f8ba06'
      d='M2.5 8.5c1.08 2.043 2.746 3.376 5 4v6c-2.254.624-3.92 1.957-5 4-1.517-1.962-2.184-4.295-2-7-.184-2.705.483-5.038 2-7Z'
      style={{
        opacity: 0.947,
      }}
    />
    <path
      fill='#4185f2'
      d='M25.5 26.5a21.628 21.628 0 0 1-5-4 186.2 186.2 0 0 1 2-3 13.117 13.117 0 0 0-7-1v-6h14a40.936 40.936 0 0 1-.5 9c-.697 2.084-1.864 3.751-3.5 5Z'
      style={{
        opacity: 0.974,
      }}
    />
    <path
      fill='#36a753'
      d='M7.5 18.5c3.143 4.814 7.477 6.147 13 4a21.628 21.628 0 0 0 5 4c-1.249 1.636-2.916 2.803-5 3.5-8.102 2.106-14.102-.394-18-7.5 1.08-2.043 2.746-3.376 5-4Z'
      style={{
        opacity: 0.919,
      }}
    />
  </svg>
)
export default Google
